import { Box, type BoxSx } from "@modernatx-internal/component-library";

import { ContentComponentProps, HexagonContent } from "../types";

type HexagonComponentProps = ContentComponentProps<HexagonContent>;

const HEXAGON_MASK = `url("data:image/svg+xml;utf8,\
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 264 239' fill='none'>\
  <path fill='white' d='M206.923 226.281L260.629 132.219C265.124 124.374 265.124 114.626 260.629 106.781L206.923 12.7192C202.428 4.87444 194.124 0 185.135 0H78.941C69.9518 0 61.6482 4.87444 57.1537 12.7192L3.37094 106.781C-1.12366 114.626 -1.12366 124.374 3.37094 132.219L57.1537 226.281C61.6482 234.126 69.9518 239 78.941 239H185.135C194.124 239 202.428 234.126 206.923 226.281Z'/>\
</svg>") center / contain no-repeat`;

export const Hexagon = ({
  fillColor,
  hexagonContent,
  size = "legacy",
  sx
}: HexagonComponentProps) => {
  const sizing: BoxSx =
    size === "responsive"
      ? {
          aspectRatio: () => "358 / 324",
          maxWidth: [() => "358px", null, () => "264px"],
          pb: "spacing-8",
          px: [() => "64px", null, () => "18px"],
          pt: 0,
          width: () => "100%"
        }
      : {
          aspectRatio: () => "239 / 264",
          p: 4,
          width: () => "239px"
        };

  const styles: BoxSx = {
    ...sizing,
    background: fillColor,
    WebkitMask: HEXAGON_MASK,
    mask: HEXAGON_MASK,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    ...sx
  };

  return (
    <Box id="hexagon-box" sx={styles}>
      {hexagonContent}
    </Box>
  );
};
